module.exports = __webpack_public_path__ + "img/crc-08.8161b031.jpg";